export class PaginationOptions {
  perPage: number | string = 10;
  pageNumber: number = 1;
  sort: string = 'date_updated';
  direction: string = 'asc';
  filter: string = 'not_trashed';
  search?: string = '';
  searchField?: string = '';
  startDate?: number | null;
  endDate?: number | null;
  purposeUuid?: string | null;
  module?: string | null;
  activityType?: string | null;

  private section!: string;

  public toggleDirection() {
    this.direction = this.direction === 'desc' ? 'asc' : 'desc';
  }

  public toggleFilter() {
    this.filter = this.filter === 'trashed' ? 'not_trashed' : 'trashed';
  }

  public setSearchField(feild: string) {
    this.searchField = feild;
  }

  public resetDirection() {
    this.direction = 'asc';
  }

  public directionIsAsc(): boolean {
    return this.direction === 'asc';
  }

  constructor(options: PaginationOptionsInterface, section: string, useSaved: boolean = true) {
    this.section = section;
    // TODO
    // let savedOptionsForSection = localStorage.getItem(section);
    // if (savedOptionsForSection && useSaved) {
    //   this.perPage = JSON.parse(savedOptionsForSection).perPage;
    //   this.pageNumber = this.pageNumber; // pageNumber does not need to be restudented
    //   this.sort = JSON.parse(savedOptionsForSection).sort;
    //   this.searchField = JSON.parse(savedOptionsForSection).searchField;
    //   this.direction = JSON.parse(savedOptionsForSection).direction;
    //   this.search = this.search; // search does not need to be restudented
    //   this.filter = this.filter; // filter does not need to be restudented
    //   return;
    // }

    if (options.perPage) {
      if (options.perPage === 'ALL') {
        this.perPage = 0;
      } else {
        this.perPage = options.perPage;
      }
    }
    if (options.pageNumber) {
      this.pageNumber = options.pageNumber;
    }
    if (options.sort) {
      this.sort = options.sort;
    }
    if (options.direction) {
      this.direction = options.direction;
    }

    if (options.filter) {
      this.filter = options.filter;
    }

    this.saveUpdatedOptions();
  }

  public saveUpdatedOptions() {
    localStorage.setItem(
      this.section,
      JSON.stringify({
        perPage: this.perPage,
        pageNumber: this.pageNumber,
        sort: this.sort,
        direction: this.direction,
        filter: this.filter,
      })
    );
  }

  public static getPaginationQueryParameters(
    paginationOptions: PaginationOptions
  ): string {
    let params = `page=${paginationOptions.pageNumber}&perPage=${paginationOptions.perPage}&sort=${paginationOptions.sort}&direction=${paginationOptions.direction}&filter=${paginationOptions.filter}&search=${paginationOptions.search}&search_field=${paginationOptions.searchField}`;
    // Additive day-filter: only appended when BOTH dates are set, so every list
    // that never sets them emits a byte-identical query string to before.
    if (paginationOptions.startDate != null && paginationOptions.endDate != null) {
      params += `&startDate=${paginationOptions.startDate}&endDate=${paginationOptions.endDate}`;
    }
    // Additive purpose filter: only appended when set, so other lists are unaffected.
    if (paginationOptions.purposeUuid != null && paginationOptions.purposeUuid !== '') {
      params += `&purpose=${paginationOptions.purposeUuid}`;
    }
    // Additive Audit Flow filters — module (subject) and activity type. Only appended when set.
    if (paginationOptions.module != null && paginationOptions.module !== '' && paginationOptions.module !== 'ALL') {
      params += `&module=${paginationOptions.module}`;
    }
    if (paginationOptions.activityType != null && paginationOptions.activityType !== '' && paginationOptions.activityType !== 'ALL') {
      params += `&type=${paginationOptions.activityType}`;
    }
    return params;
  }
}

interface PaginationOptionsInterface {
  perPage?: number | string;
  pageNumber?: number;
  sort?: string;
  direction?: string;
  filter?: string;
  search?: string;
}
